import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, ViewChild, ElementRef, ViewChildren } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { take, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { MunicipiosRecuperarService } from '../../../../core/providers/services/municipios-recuperar/municipios-recuperar.service';
import { CommonService } from '../../../../core/providers/forms/common.service';
import { ComprobarClientesService } from 'src/app/core/providers/services/comprobar-clientes/comprobar-clientes.service';
import { SectoresService } from 'src/app/core/providers/services/sectores/sectores.service';
import { Numbers } from 'src/app/utils/constants';
import LegalStepTwoComponentUtils from './legal-step-two.components.utils';
import LegalStepTwoComponentUtilsExtended from './legal-step-two.components.utils-extended';
import { CheckClientsResModel } from 'src/app/core/models/comprobar-clientes-res.model';

@Component({
  selector: 'app-legal-step-two',
  templateUrl: './legal-step-two.component.html',
  styleUrls: ['./legal-step-two.component.scss']
})
export class LegalStepTwoComponent implements OnInit, OnDestroy {
  //#region Constructor
  /**
   * constructor
   * @param municipalitySrv municipalitySrv
   * @param commons commons
   * @param sectorsSrv sectorsSrv
   * @param clients clients
   * @param gtmService gtmService
   */
  constructor(
    private municipalitySrv: MunicipiosRecuperarService,
    private commons: CommonService,
    readonly sectorsSrv: SectoresService,
    private clients: ComprobarClientesService,
    private gtmService: GoogleTagManagerService
  ) {
    this.municipalitySrv = municipalitySrv;
    this.commons = commons;
    this.sectorsSrv = sectorsSrv;
    this.clients = clients;
    this.gtmService = gtmService;
    this.utils = new LegalStepTwoComponentUtils(this.sectorsSrv);
    this.utilsExtended = new LegalStepTwoComponentUtilsExtended();
   }

  @Input() formData: FormGroup;
  @Input() formConfig: any;
  @Input() step: any;
  @Input() clickBtnPos: string;
  @Output() clickBtn: EventEmitter<'back' | 'next'> = new EventEmitter();
  @Output() insuredChoosed: EventEmitter<'Particular' | 'Empresa'> = new EventEmitter();

  @ViewChild('selectType', { static: false }) selecttype: any;
  @ViewChild('numType', { read: ElementRef, static: false }) inputtype: ElementRef;
  @ViewChild('inputN', { read: ElementRef, static: false }) inputN: ElementRef;
  @ViewChild('inputFS', { read: ElementRef, static: false }) inputFS: ElementRef;
  @ViewChild('inputEmail', { read: ElementRef, static: false }) inputEmail: ElementRef;
  @ViewChild('inputP', { read: ElementRef, static: false }) inputP: ElementRef;
  @ViewChild('inputD', { read: ElementRef, static: false }) inputD: ElementRef;
  @ViewChild('zipcode', { read: ElementRef, static: false }) inputZ: ElementRef;
  @ViewChild('inputC', { static: false }) selectC: any;
  @ViewChild('inputD2', { read: ElementRef, static: false }) inputD2: ElementRef;
  @ViewChild('zipcode2', { read: ElementRef, static: false }) inputZ2: ElementRef;
  finish = new Subject();
  insureSelected: string;
  currentStep = 0;
  patternEmail: RegExp = this.commons.patternsForm('email');
  patternMobile: RegExp = this.commons.patternsForm('mobile');
  patternCP: RegExp = this.commons.patternsForm('cp');
  chooseOne: string;
  public idMunicipioRecuperado = '';
  public utils: any;
  public utilsExtended: any;

  /**
   * ngOnInit
   */
  ngOnInit() {
    this.currentStep = this.step;
    this.insureSelected = this.formData.get('insureSelected').value.chosed;
    if (this.insureSelected === 'particularLegalAsistance') {
      this.utilsExtended.checkShowRentedHouse(this.formData.get([this.insureSelected, 'insuranceType']).value.priority,
        this.formData.get(this.formConfig.rentedHouse.linkFormPath).value);
      this.utils.setValidator(this.formData, this.formConfig, this.patternEmail, this.patternMobile, this.patternCP);
      this.formData = this.utils.formDataUtils;
      this.utilsExtended.getProductChoosedUtilsExtended(this.formData, this.insureSelected,
        this.formConfig);
      this.initObs();
    }
    if (this.insureSelected === 'ownerLegalAsistance') {
      this.chooseOne = this.getInsuredChoosed();
      this.utils.setValidatorOwner(this.formData, this.formConfig, this.patternEmail,
         this.patternMobile, this.patternCP, this.chooseOne);
      this.formData = this.utils.formDataUtils;
      this.formConfig = this.utils.formConfigUtils;
      this.utils.setDefaultValueTypeOwner(this.formData, this.formConfig);
      this.formData = this.utils.formDataUtils;
      this.utilsExtended.getProductChoosedUtilsExtended(this.formData, this.insureSelected,
        this.formConfig);
      this.initSectors(this.formConfig, this.utilsExtended.formDataValue);
      this.initObs();
    }
    window.scrollTo(0, 0);
  }

  /**
   * ngOnDestroy
   */
  ngOnDestroy() {
    this.finish.next(true);
  }

  /**
   * initSectors
   * @param formConfig formConfig
   * @param formDataValue formDataValue
   */
  initSectors(formConfig: any, formDataValue: any): void {
    this.sectorsSrv.getSectors()
      .pipe(take(1))
      .subscribe((sectors) => {
        formConfig.bussines.companySector.options.list = sectors;
        formDataValue.sectorList = sectors;
      });
  }

  /**
   * initObs
   */
  initObs(): void {
    this.formData.get(this.insureSelected).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(() => {
        })
      ).subscribe();
    if (this.insureSelected === 'particularLegalAsistance') {
      this.initLegalParticular();
    }
    if (this.insureSelected === 'ownerLegalAsistance') {
      this.initLegalPropietario();
    }
    this.formData.get([this.insureSelected, 'insuredData', 'telephone']).setValue('');
  }

  /**
   * initLegalParticular
   */
  initLegalParticular(): void {
    this.formData.get(this.formConfig.documentType.linkFormPath).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(el => {
          if (this.formData.get(this.formConfig.documentNumber.linkFormPath).value !== '') {
            this.formData.get(this.formConfig.documentNumber.linkFormPath).setValue('');
          }
        })
      ).subscribe();
    this.formData.get(this.formConfig.rentedHouse.linkFormPath).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap((el) => {
          this.utilsExtended.initLegalParticularUtilsExtended(this.formData, el,
            this.formConfig, this.patternCP);
          this.formData = this.utilsExtended.formDataUtilsExtended;
        })
      ).subscribe();
  }

  /**
   * initLegalPropietario
   */
  initLegalPropietario(): void {
    this.formData.get(this.formConfig.documentType.linkFormPath).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(el => {
          const auxValueNum: any = this.formData.get(this.formConfig.documentNumber.linkFormPath).value;
          auxValueNum.toString();
          if (el.name === 'CIF' && this.getInsuredChoosed() === 'Empresa') {
            this.utilsExtended.changeBooleans(true);
          } else if (this.utils.disabledRazSo) {
            this.utilsExtended.showLegalCompany = false;
            this.utils.enableData(this.formData, this.formConfig, this.insureSelected);
            this.formData = this.utils.formDataUtils;
          } else {
            this.utilsExtended.changeBooleans(false);
          }
          if (auxValueNum !== '') {
            this.formData.get(this.formConfig.documentNumber.linkFormPath).setValue('');
          }
          if (el !== null && el.name === 'CIF' && auxValueNum !== '' && auxValueNum.length >= Numbers.number9) {
            this.getDataBD();
          }
        })
      ).subscribe();
    this.formData.get(this.formConfig.documentNumber.linkFormPath).valueChanges
      .pipe(
        takeUntil(this.finish),
        tap(el => {
          if (this.formData.get(this.formConfig.documentType.linkFormPath).value.name === 'CIF' && el !== '' &&
              el.length >= Numbers.number9) {
            this.getDataBD();
          }
        })
      ).subscribe();
  }

  /**
   * triggerCkeckClient
   * @param auxValueType auxValueType
   * @param auxValue auxValue
   * @param auxValueName auxValueName
   * @param auxValueSurname auxValueSurname
   */
  triggerCkeckClient(auxValueType: any, auxValue: any, auxValueName: any, auxValueSurname: any): void {
    if (auxValueType === 'NIF' && auxValue !== '' && auxValueName !== '' && auxValueSurname !== '') {
      let auxName = '';
      const auxValueNum: any = this.formData.get(this.formConfig.documentNumber.linkFormPath).value;
      auxValueNum.toString();
      if (this.insureSelected === 'ownerLegalAsistance' && this.chooseOne === 'Particular') {
        auxName = this.formData.get(this.formConfig.particular.name.linkFormPath).value;
      } else if (this.insureSelected === 'ownerLegalAsistance' && this.chooseOne === 'Empresa') {
        auxName = this.formData.get(this.formConfig.bussines.direction.linkFormPath).value;
      } else {
        auxName = this.formData.get(this.formConfig.name.linkFormPath).value;
      }
      const data: any = {
        cif: auxValueNum,
        nombre: auxName,
        apellido1: this.formData.get(this.formConfig.firstSurname.linkFormPath).value
      };
      if (auxValueNum.length >= Numbers.number9) {
        this.clients.getCheckClients(data)
          .pipe(take(1))
          .subscribe((client) => {
            this.triggerCkeckClientZero(client);
        });
      }
    }
  }

  /**
   * triggerCkeckClientZero
   * @param client client
   */
  triggerCkeckClientZero(client: CheckClientsResModel): void {
    if (client.idCliente === 0) {
      this.formData.get(this.formConfig.firstSurname.linkFormPath).setValue('');
      if (this.insureSelected === 'ownerLegalAsistance' && this.chooseOne === 'Particular') {
        this.formData.get(this.formConfig.particular.name.linkFormPath).setValue('');
        this.utils.showModalDialog2();
      } else {
        if (this.insureSelected === 'ownerLegalAsistance' && this.chooseOne === 'Empresa') {
          this.formData.get(this.formConfig.bussines.direction.linkFormPath).setValue('');
        } else {
          this.formData.get(this.formConfig.name.linkFormPath).setValue('');
        }
        this.utils.showModalDialog2();
      }
    } else {
      // Enviamos al siguiente paso
      this.utilsExtended.typeChange = { name: 'typeDocSend', value: 'valid' };
      this.utils.datalayer(this.formData, this.gtmService);
      this.clickBtn.emit('next');
    }
  }

  /**
   * setFieldValidate
   * @param ev ev
   * @param auxTypeVal auxTypeVal
   */
  setFieldValidate(ev: any, auxTypeVal: any): void {
    if (auxTypeVal !== '' && auxTypeVal.name === 'NIF') {
      this.checkDocumentBlur(this.formConfig.documentNumber.linkFormPath);
    } else if (auxTypeVal !== '' && auxTypeVal.name !== 'NIF') {
      this.utilsExtended.typeChange = { name: 'typeDocSend', value: 'valid' };
      this.utils.datalayer(this.formData, this.gtmService);
      this.utils.datalayer2(this.formData, this.gtmService);
      this.clickBtn.emit(ev);
    } else {
      this.utilsExtended.typeChange = { name: 'typeDocSend', value: 'error' };
    }
  }

  /**
   * clickButton
   * @param ev ev
   */
  public clickButton(ev: 'back' | 'next'): void {
    if (ev === 'next' && this.insureSelected === 'particularLegalAsistance' && this.utilsExtended.showRentedHouse &&
        this.formData.invalid) {
      this.setFieldError();
    } else if (ev === 'next' && this.insureSelected === 'particularLegalAsistance' && this.utilsExtended.showRentedHouse) {
      this.setFieldValidate(ev, this.formData.get(this.formConfig.documentType.linkFormPath).value);
    } else if (ev === 'next') {
      this.setFieldValidate(ev, this.formData.get(this.formConfig.documentType.linkFormPath).value);
    } else {
      if (this.insureSelected === 'particularLegalAsistance') {
        this.utils.removeValidator(this.formData, this.formConfig);
        this.formData = this.utils.formDataUtils;
      }
      if (this.insureSelected === 'ownerLegalAsistance') {
        this.utils.removeValidatorOwner(this.formData, this.formConfig);
        this.formData = this.utils.formDataUtils;
      }
      this.clickBtn.emit(ev);
    }
  }

  /**
   * setFieldError
   */
  setFieldError(): void {
    if (this.selecttype.ngModelSelected.name === undefined) {
      this.selecttype.fieldHasErrorB = true;
      this.selecttype.fieldTouch = true;
    }
    if (this.selectC.ngModelSelected.name === undefined) {
      this.selectC.fieldHasErrorB = true;
      this.selectC.fieldTouch = true;
    }
    this.inputtype.nativeElement.children[0].children[0].children[0].focus();
    this.inputN.nativeElement.children[0].children[0].children[0].focus();
    this.inputFS.nativeElement.children[0].children[0].children[0].focus();
    this.inputEmail.nativeElement.children[0].children[0].children[0].focus();
    this.inputP.nativeElement.children[0].children[0].children[0].focus();
    this.inputD.nativeElement.children[0].children[0].children[0].focus();
    this.inputZ.nativeElement.children[0].children[0].children[0].focus();
    this.inputD2.nativeElement.children[0].children[0].children[0].focus();
    this.inputZ2.nativeElement.children[0].children[0].children[0].focus();
  }

  /**
   * emitInsuredChoosed
   * @param ev ev
   * @returns returns
   */
  public emitInsuredChoosed(ev: 'Particular' | 'Empresa'): void {
    if (!this.formData) { return; }
    this.formData.get(this.formConfig.typeOwner.linkFormPath).setValue(ev);
    this.insuredChoosed.emit(ev);
    this.chooseOne = this.getInsuredChoosed();
    this.utils.setValidatorOwner(this.formData, this.formConfig, this.patternEmail, this.patternMobile, this.patternCP,
      this.chooseOne);
    this.formData = this.utils.formDataUtils;
    this.formConfig = this.utils.formConfigUtils;
    setTimeout(() => {
      this.utilsExtended.checkEnableCompanyUtilsExtended(this.formData, this.formConfig, this.chooseOne);
    }, Numbers.number100);
  }

  /**
   * getInsuredChoosed
   * @returns returns
   */
  public getInsuredChoosed(): 'Particular' | 'Empresa' {
    if (this.formData) {
      return this.formData.get(this.formConfig.typeOwner.linkFormPath).value;
    }
  }

  /**
   * getMunicipality
   * @param code code
   * @param field field
   */
  getMunicipality(code: number, field?: any): void {
    this.municipalitySrv.getMunicipality(code)
      .pipe(take(1))
      .subscribe((municipality: any) => {
        this.utilsExtended.getMunicipalityUtilsExtended(municipality, field, 'rentedHouseData',
          this.insureSelected, this.formData, this.idMunicipioRecuperado);
        this.formData = this.utilsExtended.formDataUtilsExtended;
      });
  }

  /**
   * changeCountry
   * @param event event
   */
  changeCountry(event: any): void {
    this.municipalitySrv.getMunicipalityNoSpain(event.id)
      .pipe(take(1))
      .subscribe((municipality) => {
        this.utilsExtended.changeCountryUtilsExtended(municipality, this.formData, this.insureSelected);
        this.formData = this.utilsExtended.formDataUtilsExtended;
      });
  }

  /**
   * changeMuni
   * @param event event
   * @param lista lista
   */
  changeMuni(event: any, lista?: any): void {
    if (event.Des_Provincia !== undefined) {
      this.utilsExtended.changeMuniUtils(lista, event);
      this.formData.get([this.insureSelected, 'insuredData', 'municipality'])
        .setValue({ name: event.Des_Municipio, id: event.Id_Municipio });
      this.formData.get([this.insureSelected, 'insuredData', 'provinceId']).setValue(event.Id_Provincia);
    }
  }

  /**
   * getDataBD
   */
  getDataBD(): void {
    this.clients.getClientes(this.formData.get(this.formConfig.documentNumber.linkFormPath).value)
      .pipe(take(1))
      .subscribe((client) => {
        if (client !== null) {
          this.setCIFData(client);
        }
      });
  }

  /**
   * setCIFData
   * @param data data
   */
  setCIFData(data: any): void {
    this.idMunicipioRecuperado = data.idMunicipio;
    if (data.codPostal !== '') {
      this.getMunicipality(data.codPostal);
    }
    this.utils.setCIFDataUtils(data, this.utilsExtended.formDataValue, this.formData, this.formConfig);
    this.formData = this.utils.formDataUtils;
  }

  /**
   * dataEmit
   * @param ev ev
   */
  dataEmit(ev: any): void {
    if (ev !== null && ev !== undefined) {
      let keyPress: any = null;
      if (Object.keys(ev).length > 0) { keyPress = ev; }

      if (keyPress !== null && keyPress.enter !== undefined && keyPress.enter) {
        const keyPressValue: any = keyPress.value;
        if (keyPressValue !== undefined) {
          this.setCIFData(keyPress.value);
        } else {
          this.getMunicipality(this.formData.get(keyPress.field).value, keyPress.field);
        }
      }
    }
  }

  /**
   * dataEmitBlur
   * @param event event
   */
  dataEmitBlur(event: any): void {
    let keyValueControl = '';
    if (event.control !== undefined) { keyValueControl = event.control; }
    let keyValueName = '';
    if (event.fieldName !== undefined) { keyValueName = event.fieldName; }
    this.utilsExtended.keyValueControl(keyValueControl, this.formData.get(this.formConfig.postalCode.linkFormPath).value);
  }

  /**
   * checkDocumentBlur
   * @param keyValueName keyValueName
   */
  checkDocumentBlur(keyValueName: any): void {
    const auxValueSurname: any = this.formData.get(this.formConfig.firstSurname.linkFormPath).value;
    const auxValueType: any = this.formData.get(this.formConfig.documentType.linkFormPath).value;
    const auxValueNum: any = this.formData.get(this.formConfig.documentNumber.linkFormPath).value;
    let nameF = '';
    let auxValueName = '';
    if (this.insureSelected === 'ownerLegalAsistance' && this.getInsuredChoosed() === 'Particular') {
      auxValueName = this.formData.get(this.formConfig.particular.name.linkFormPath).value;
    } else if (this.insureSelected === 'ownerLegalAsistance' && this.getInsuredChoosed() === 'Empresa') {
      auxValueName = this.formData.get(this.formConfig.bussines.direction.linkFormPath).value;
    } else {
      auxValueName = this.formData.get(this.formConfig.name.linkFormPath).value;
    }
    if (keyValueName.includes('documentNumber')) {
      nameF = 'documentNumber';
    } else if (keyValueName.includes('firstSurname')) {
      nameF = 'firstSurname';
    } else if (keyValueName.includes('name')) {
      nameF = 'name';
    }  else {
      nameF = '';
    }
    switch (nameF) {
      case 'documentNumber':
        this.triggerCkeckClient(auxValueType.name, auxValueNum, auxValueName, auxValueSurname);
        break;
      case 'name':
        this.triggerCkeckClient(auxValueType.name, auxValueNum, auxValueName, auxValueSurname);
        break;
      case 'firstSurname':
        this.triggerCkeckClient(auxValueType.name, auxValueNum, auxValueName, auxValueSurname);
        break;
      default:
        break;
    }
  }

  /**
   * getModalState
   * @returns returns
   */
  public getModalState(): boolean {
    return this.utilsExtended.showModal;
  }

  /**
   * getModalState2
   * @returns returns
   */
  public getModalState2(): boolean {
    return this.utils.showModal2;
  }

  /**
   * changePrefix
   */
  changePrefix(): void {
    this.utilsExtended.getPrefixChanged(this.formData.value.particularLegalAsistance,
      this.formData.value.ownerLegalAsistance, this.formData);
    this.formData.get([this.insureSelected, 'insuredData', 'telephone']).setValue('');
  }
}
